import { render, staticRenderFns } from "./ScrollPane.vue?vue&type=template&id=be684e16&scoped=true&"
import script from "./ScrollPane.vue?vue&type=script&lang=js&"
export * from "./ScrollPane.vue?vue&type=script&lang=js&"
import style0 from "./ScrollPane.vue?vue&type=style&index=0&id=be684e16&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be684e16",
  null
  
)

component.options.__file = "ScrollPane.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/layout/components/TagsView/ScrollPane.vue
// module id = null
// module chunks = 